/* create functional component command: rafce */
import React from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import Footer from './components/footer/Footer'

import Experience from './components/sections/experience/Experience'
import Portfolio from './components/sections/portfolio/Portfolio'
import About from './components/sections/about/About'
import Clients from './components/sections/clients/Clients'
import HeroSlider from './components/shared/hero-slider/HeroSlider'



const App = () => {

  return (
    <>
      <HeroSlider></HeroSlider>
      <Header />
      <Nav />
      <About />
      <Clients />
      <Experience />
      <Portfolio />
      <Footer />
    </>
  )
}

export default App
